import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { HttpBlockRequestInterceptor } from './http-block-request.interceptor';
import { HttpErrorInterceptor } from './http-error.interceptor';
import { HttpServerCacheInterceptor } from './http-server-cache.interceptor';
import { HttpTimeoutInterceptor } from './http-timeout.interceptor';
import { HttpTransferStateInterceptor } from './http-transfer-state.interceptor';

/**
 * An NgModule providing a set of HTTP Interceptors
 *
 * !! BE AWARE: Provider declaration order below matters !!
 * 1. HttpTransferStateInterceptor
 * 2. HttpServerCacheInterceptor
 * 3. HttpErrorInterceptor
 * 4. HttpBlockRequestInterceptor
 * 5. HttpTimeoutInterceptor
 */
@NgModule({
  providers: [
    HttpTransferStateInterceptor,
    HttpServerCacheInterceptor,
    HttpErrorInterceptor,
    HttpTimeoutInterceptor,
    HttpBlockRequestInterceptor,
    { provide: HTTP_INTERCEPTORS, useExisting: HttpTransferStateInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useExisting: HttpServerCacheInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useExisting: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useExisting: HttpBlockRequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useExisting: HttpTimeoutInterceptor, multi: true }
  ]
})
export class HttpInterceptorsModule {}

export * from './http-transfer-state.interceptor';
export * from './http-server-cache.interceptor';
export * from './http-timeout.interceptor';
export * from './http-error.interceptor';
export * from './http.helpers';
